<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Pickleball Inauguration </h1>
                </div>
            </div>
        </div>
    </div>
</section>
<section class>
    <div class="section-lg">
        <div class="container">
            <h2>Pickleball Inauguration</h2>
            <div class="text-justify">
                <p>GHRCACS, Nagpur came together with dignitaries, faculty, and students for the Pickleball inauguration — marking the start of a fresh sporting chapter.</p>
            </div>
            <div class="row mb-20 mt-5">
                <div class="col-md-3 col-6">
                    <div class="gallery-item">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/pickleball-2.webp"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/pickleball-2.webp"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/pickleball-3.webp"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/pickleball-3.webp"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/pickleball-4.webp"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/pickleball-4.webp"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/pickleball-5.webp"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/pickleball-5.webp"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>